import type { Ref, TextareaHTMLAttributes } from 'react';
import classNames from 'classnames';

import { useFormFieldControl } from '@/components/atoms/FormField/FormFieldContext';
import styles from '@/components/atoms/FormField/formControl.module.scss';

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    /** Marks the field invalid. Inside a FormField an `error` does this already. */
    invalid?: boolean;
    ref?: Ref<HTMLTextAreaElement>;
}

/** A multi-line input. The ref reaches the `<textarea>`. */
export default function TextArea(props: TextAreaProps) {
    const {
        ref,
        className,
        id,
        invalid,
        'aria-describedby': ariaDescribedBy,
        ...textAreaProps
    } = props;
    const accessible = useFormFieldControl({
        id,
        invalid,
        'aria-describedby': ariaDescribedBy,
    });

    return (
        <textarea
            ref={ref}
            {...accessible}
            {...textAreaProps}
            className={classNames(styles.control, className)}
        />
    );
}
